import { render, staticRenderFns } from "./PageEditorContentPanelTabBtn.vue?vue&type=template&id=5d17277f&scoped=true"
import script from "./PageEditorContentPanelTabBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorContentPanelTabBtn.vue?vue&type=script&lang=js"
import style0 from "./PageEditorContentPanelTabBtn.vue?vue&type=style&index=0&id=5d17277f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d17277f",
  null
  
)

export default component.exports